export { default as Copy, ReactComponent as CopyComponent } from './copy.svg';
